import { memo } from 'react';
import { BaseEdge, getSmoothStepPath, EdgeLabelRenderer } from '@xyflow/react';

const AtlasEdge = memo(({
  id, sourceX, sourceY, targetX, targetY,
  sourcePosition, targetPosition, style = {}, selected, markerEnd
}) => {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX, sourceY, targetX, targetY,
    sourcePosition, targetPosition,
    borderRadius: 16,
  });

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          stroke: style.stroke || '#E2E2E2',
          strokeWidth: selected ? 3 : 1.5,
          cursor: 'pointer',
          ...style,
        }}
        interactionWidth={24}
      />
      {selected && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              pointerEvents: 'none',
            }}
            className="w-2 h-2 rounded-full bg-cobalt"
          />
        </EdgeLabelRenderer>
      )}
    </>
  );
});

AtlasEdge.displayName = 'AtlasEdge';
export default AtlasEdge;
